'use strict';

angular.module('footer', []);
